
import { defineComponent } from '@vue/runtime-core'

import { selectSearch } from '@/directives/select-search'
import { ISearchCompany } from '@/models'

export default defineComponent({
    props: {
        previewForecasts: Array,
        search: String,
        url: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            selectedPreviewItem: -1,
        }
    },

    directives: {
        selectSearch,
    },

    mounted() {
        document.addEventListener('keyup', this.onKeyUp)
    },

    beforeUnmount() {
        document.removeEventListener('keydown', this.onKeyUp)
    },

    watch: {
        previewForecasts() {
            this.selectedPreviewItem = -1
        },
    },

    methods: {
        onKeyUp(e: KeyboardEvent) {
            switch (e.key) {
                case 'ArrowDown':
                    this.selectResultDown()
                    break
                case 'ArrowUp':
                    this.selectResultUp()
                    break
                case 'Enter':
                    this.chooseResult()
                    break
            }
        },

        selectResultDown() {
            this.selectedPreviewItem = !this.previewForecasts?.length ? -1 : this.previewForecasts?.length > this.selectedPreviewItem - 1 ? this.selectedPreviewItem + 1 : 0
        },

        selectResultUp() {
            this.selectedPreviewItem = !this.previewForecasts?.length ? -1 : this.selectedPreviewItem > 0 ? this.selectedPreviewItem - 1 : this.previewForecasts?.length - 1
        },

        chooseResult() {
            if (!this.previewForecasts?.length) {
                return
            }

            const selectedPreviewItem = this.selectedPreviewItem === -1 ? 0 : this.selectedPreviewItem
            this.openInNewTab(this.url + (this.previewForecasts[selectedPreviewItem] as ISearchCompany).ticker)
        },

        openInNewTab(href: string) {
            Object.assign(document.createElement('a'), {
                target: '_blank',
                href: href,
            }).click()
        },
    },
})
